import { UserDeletionHistoryListSearchCriteria } from '../models/user-deletion-history.model';

export class UserDeletionHistoryLoad {
  public static readonly type = '[User Deletion History] Load';

  constructor(public payload: UserDeletionHistoryListSearchCriteria) {}
}

export class UserDeletionHistoryInitialState {
  public static readonly type = '[User Deletion History] Set initial state';
}
